module.exports = __webpack_public_path__ + "img/login1.d814adb7.png";